import React from "react";
import {Button} from 'primereact/button';

function Hero({imageClass, title, subTitle, explanation, buttonText = '', buttonCompanyWeb = false}) {
    return (
        <>
            <div className="hero-backgrounds">
                <div className={`hero-background-${imageClass}`}/>
            </div>

            <article className="hero ebp">
                <div className="hero-message-wrapper ebp">
                    <h1><div dangerouslySetInnerHTML={{__html: title}}/></h1>
                    <br/>
                    <p className="sub-title-product">{subTitle}</p>
                    <br/>
                    <p>
                        <div dangerouslySetInnerHTML={{__html: explanation}}/>
                    </p>
                    <br/>
                    {buttonText !== ''
                        ? buttonCompanyWeb === true ?
                            <Button link onClick={() =>  window.open(`${process.env.REACT_APP_LINK_COMPANY_WEB}`, '_blank')} className='colorful-button btn-hero'>{buttonText}</Button>
                            : <Button onClick={() => window.open(`${process.env.REACT_APP_LINK_LOGIN}`)} className='colorful-button-individu btn-hero'>{buttonText}</Button>
                        : <div/>
                    }
                </div>
            </article>
        </>
    );
}

export default Hero;
